import Axios from "axios";

const RESOURCE = "/api/admin";

export default {
  /**
   * Get User By Id
   * Admin only
   */
  getUser(id) {
    return Axios.get(`${RESOURCE}/user/${id}`);
  },

  /**
   * Get User Media Libary By Id
   * Admin only
   */
  getUserLibrary(id) {
    return Axios.get(`${RESOURCE}/user/library/${id}`);
  },



  getTotalJobsThisMonth(data) {
    return Axios.post(`${RESOURCE}/jobs/getTotalJobsThisMonth`, { user_id: data })
  },
  /**
   *
   * Get verbose logs for user
   * Admin only
   *
   */
  getUserLogs(data) {
    return Axios.get("/api/logs/pullLogEntries/", data);
  },

  /**
   * @param {string} query params
   *  ex: ?page=1&limit=20&date=1
   */
  queryUsers(query) {
    return Axios.get(`${RESOURCE}/user/${query}`);
  },

  /**
   * Edit user
   * @param {obj} req.body
   */
  updateUser(id, data) {
    return Axios.put(`${RESOURCE}/user/${id}/billing`, data);
  },

  cancelPlan(id) {
    return Axios.put(`${RESOURCE}/user/${id}/cancel`);
  },

  removeSeat(id) {
    return Axios.put(`${RESOURCE}/user/${id}/removeSeat`);
  },

  /**
   * update user record
   * @param {obj} req.body
   */
  updateUserRecord(data) {
    return Axios.post(`${RESOURCE}/user/updateUserRecord`, data);
  },

  /**
   * Delete user
   * @param {obj} req.body
   */
  deleteUser(id, data) {
    return Axios.post(`${RESOURCE}/user/${id}/delete`, data);
  },

  /**
   * Edit job
   * @param {obj} req.body - status
   */
  updateJob(id, data) {
    return Axios.put(`${RESOURCE}/job/${id}`, data);
  },

  /**
   * Retry job
   * @param {obj} req.body - status
   */
  retryJob(id, data) {
    return Axios.put(`${RESOURCE}/job/${id}/retry`, data);
  },

  /**
   * Re-assign Video
   * @param {obj} req.body - status
   */
  reassignVideo(data) {
    return Axios.post(`${RESOURCE}/job/reassign`, data);
  },

  /**
   * Get user billing status
   * @param {string} user.id - User Identifier
   */
  getBillingStatus(id) {
    return Axios.get(`${RESOURCE}/user/${id}/billing`);
  },

  /**
   * Get billing options
   */
  getBillingOptions() {
    return Axios.get(`${RESOURCE}/user/billing/options`);
  },

  /**
   * Add subscription for user
   * @param {obj} req.body: plan, stripe token, etc.
   */
  createSubscription(id, data) {
    return Axios.post(`${RESOURCE}/user/${id}/billing/subscribe`, data);
  },

  /**
   * Add subscription for user
   * @param {obj} req.body: plan, stripe token, etc.
   */
  createStripeCustomer(id, data) {
    return Axios.post(`${RESOURCE}/user/${id}/billing`, data);
  },

  /**
   * Edit existing subscription
   * @param {obj} req.body: plan, stripe token, event, & duration
   */
  updateBilling(id, data) {
    return Axios.put(`${RESOURCE}/user/${id}/billing`, data);
  },

  /**
   * Change Email Address
   * Same as email prefs - need to consolidate
   * @param {string} user.id
   * @param {object} email - e.g. { email: 'string' }
   */
  updateUserEmail(id, email) {
    return Axios.put(`${RESOURCE}/user/${id}/email`, email);
  },

  /**
   * Change Password
   * @param {string} user.id
   */
  updateUserPassword(id, data) {
    return Axios.put(`${RESOURCE}/user/${id}/password`, data);
  },

  /**
   * Change Users Plan Name
   * @param {object} plan - e.g. { planName: 'string, planType: 'string }
   */
  updateUserPlanName(id, data) {
    return Axios.put(`${RESOURCE}/user/${id}/plan`, data);
  },

  // get deflector event data
  getDeflectorData(id) {
    return Axios.get(`${RESOURCE}/user/${id}/events`);
  },

  // get deflector event data
  changeUserTrial(id, trialEndAt) {
    return Axios.put(`${RESOURCE}/user/${id}/trial`, { trialEndAt });
  },
};
